module.exports = __webpack_public_path__ + "static/media/Tea.35e4eafa.webp";